import { Link } from 'react-router-dom';
import { getHotProducts } from '@/mocks/products';

export default function HotProducts() {
  const products = getHotProducts();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              人气爆款推荐
            </h2>
            <p className="text-foreground-600 text-sm mt-1">万千妈妈口碑之选</p>
          </div>
          <Link
            to="/category/milk-powder"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {products.map((product) => (
            <Link
              key={product.id}
              to={`/category/${product.category}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-square overflow-hidden bg-background-200">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={product.name}
                />
                {product.badge && (
                  <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                    {product.badge}
                  </span>
                )}
              </div>
              <div className="p-3">
                <p className="text-xs text-foreground-500 mb-1">{product.brand}</p>
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {product.name}
                </h3>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-base font-bold text-primary-500">¥{product.price}</span>
                  <span className="text-xs text-foreground-400 line-through">¥{product.originalPrice}</span>
                </div>
                <div className="flex items-center gap-1 mt-1">
                  <span className="text-xs text-foreground-500">已售{product.sales > 10000 ? `${(product.sales / 10000).toFixed(1)}万` : product.sales}件</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}